import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import NotificationComponent from './Notification';
import { getRoleDisplayName } from '../../utils/roleUtils';

function Navbar() {
  const { logout, role } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-blue-800 to-slate-900 shadow-2xl border-b border-purple-500/20">
      <div className="max-w-9xl mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-14 sm:h-16">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-2 sm:space-x-4 min-w-0 flex-1">
            <div className="flex-shrink-0">
              <div className="flex items-center space-x-2 sm:space-x-3">
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-400 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg">
                  <svg className="w-4 h-4 sm:w-6 sm:h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div className="min-w-0">
                  <h1 className="text-base sm:text-xl font-bold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent truncate">
                    Adaptmate CRM
                  </h1>
                  <p className="text-[10px] sm:text-xs text-white -mt-0.5 sm:-mt-1 hidden xs:block">Lead Management System</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right side items */}
          <div className="flex items-center space-x-2 sm:space-x-4 lg:space-x-6">
            {/* Notifications */}
            <div className="relative">
              <NotificationComponent />
            </div>

            {/* User Info - Hidden on small mobile */}
            <div className="hidden md:flex items-center space-x-3 lg:space-x-4">
              <div className="text-right">
                <div className="flex items-center space-x-2">
                  <div className={`w-2 h-2 rounded-full ${
                    role === 'admin' ? 'bg-green-400' : 'bg-blue-400'
                  } animate-pulse`}></div>
                  <span className="text-xs lg:text-sm font-medium text-white">
                    {getRoleDisplayName(role)}
                  </span>
                </div>
                <p className="text-[10px] lg:text-xs text-purple-300">Online</p>
              </div>

              {/* User Avatar - Desktop only */}
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center shadow-lg">
                <svg className="w-4 h-4 lg:w-5 lg:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
            </div>

            {/* Logout Button */}
            <button
              onClick={handleLogout}
              className="group relative bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white px-2 sm:px-3 lg:px-4 py-1.5 sm:py-2 rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 flex items-center space-x-1 sm:space-x-2"
            >
              <svg className="w-3 h-3 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;